import { uuidModule } from "@/modules/uuid";
import { SessionDeletedSyncUpdateValue, SessionModelData } from "@/store/sessions/types";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { SyncErrorHandlingType } from "@/store/sync/operations/errors/SyncError";
import { IDeleteSessionOperation } from "@/store/sync/operations/types";
import {
  OptimisticSyncUpdate,
  SyncCustomErrorData,
  SyncModelData,
  SyncOperationKind,
} from "@/store/sync/types";

export class DeleteSessionOperation extends BaseSyncOperation<IDeleteSessionOperation> {
  get operationKind(): SyncOperationKind {
    return "DELETE_SESSION";
  }

  public async generateOptimisticUpdates(): Promise<OptimisticSyncUpdate<SyncModelData>[]> {
    const session = await this.store.sessions.getAsync(this.payload.id);
    if (!session) return [];

    const value: SessionDeletedSyncUpdateValue = {
      model_id: this.payload.id,
      model_kind: "SESSION",
      model_version: session.modelVersion,
    };

    const optimisticUpdate: OptimisticSyncUpdate<SessionModelData> = {
      optimistic_update_id: uuidModule.generate(),
      locally_committed_at: this.committedAt,
      kind: "DELETED",
      value,
    };

    return [optimisticUpdate];
  }

  async triggerRecompute() {
    await this.store.sessions.recompute(this.payload.id);
  }

  handleInvalidError(_errorData: SyncCustomErrorData) {
    this.ignoreError();
  }

  handlePermissionDeniedError(_errorData: SyncCustomErrorData) {
    this.ignoreError();
  }

  handleUnknownError(_errorData: SyncCustomErrorData) {
    this.ignoreError(SyncErrorHandlingType.RetryWithLimit);
  }
}
